@if (hasAppointments()) {
  <div class="appointment-ribbon-wrapper relative w-full pointer-events-none">
    <!-- Floating Toggle Tab (floats above the drawer when open, or at the bottom-right when minimised) -->
    <div
      class="appointment-ribbon-toggle absolute right-4 z-40 pointer-events-auto transition-all duration-300 ease-in-out"
      [class.bottom-3]="isMinimised$()"
      [class.-top-11]="!isMinimised$()"
    >
      <button
        type="button"
        class="inline-flex items-center gap-2 rounded-full border border-slate-700/80 bg-slate-950/95 hover:bg-slate-900 px-3 py-1.5 text-xs font-semibold text-slate-100 shadow-xl shadow-black/60 backdrop-blur-md transition-all hover:border-sky-500/50 active:scale-95 cursor-pointer"
        (click)="toggleMinimised()"
        [attr.aria-label]="getToggleLabel()"
      >
        <app-icon
          [icon]="isMinimised$() ? 'mdi-chevron-up' : 'mdi-chevron-down'"
          fontSize="16px"
          class="text-sky-400"
        ></app-icon>
        <span class="text-[11px] font-medium text-slate-200">
          {{ (isMinimised$() ? 'Appointments.Ribbon.Today' : 'Appointments.Ribbon.Today') | localizeText : "Today's Consults" }}
        </span>
        <span
          class="inline-flex min-h-5 min-w-5 items-center justify-center rounded-full border border-sky-400/40 bg-sky-500/20 px-1.5 text-[11px] font-bold leading-none text-sky-200 ring-1 ring-slate-950/80"
        >
          {{ appointmentCount() > 99 ? '99+' : appointmentCount() }}
        </span>
      </button>
    </div>

    <!-- Sliding Drawer Panel (Overlays bottom of the page) -->
    <div
      class="appointment-ribbon pointer-events-auto w-full bg-slate-950/95 border-t border-slate-800/90 shadow-2xl backdrop-blur-md px-4 py-2.5 transition-all duration-300 ease-in-out"
      [class.appointment-ribbon--minimised]="isMinimised$()"
    >
      <div class="flex items-center gap-3 overflow-x-auto pb-0.5 appointment-ribbon__scroll">
        @for (appt of service.appts$(); track appt.appointment.id) {
          <div
            class="appointment-ribbon-item flex items-center gap-3 px-3 py-1.5 rounded-2xl bg-slate-900/90 border border-slate-700/70 hover:border-sky-500/60 hover:bg-slate-850 text-white transition-all cursor-pointer shadow-md min-w-max"
            (click)="joinAppointment(appt)"
          >
            <!-- Type / Join CTA Icon -->
            <div
              class="w-8 h-8 rounded-full bg-blue-600 hover:bg-blue-500 text-white flex items-center justify-center flex-shrink-0 shadow-sm"
              [attr.aria-label]="'Join' | localizeText : 'Join'"
            >
              <app-icon
                [icon]="getAppointmentTypeIcon(appt.appointment.appointmentType)"
                fontSize="16px"
              ></app-icon>
            </div>

            <!-- Title & Time -->
            <div class="min-w-0 pr-1">
              <div class="text-xs font-semibold text-white truncate max-w-[160px]">
                {{ appt.appointment.title || ('Consultation' | localizeText : 'Consultation') }}
              </div>
              <div class="flex items-center gap-1.5 text-[11px] text-slate-400 font-medium mt-0.5">
                <app-icon icon="clock" fontSize="12px" class="text-amber-400"></app-icon>
                <span>{{ appt.appointment.startTime | localizedDate:'h:mm a' }}</span>
              </div>
            </div>

            <!-- Participants avatars -->
            <div class="flex -space-x-1.5 flex-none pl-1">
              @for (part of appt.participants; track part.id) {
                @if (part.userId !== authUserId) {
                  <div
                    class="w-7 h-7 rounded-full bg-slate-800 border border-slate-700 text-[10px] font-semibold text-slate-200 flex items-center justify-center shadow-sm"
                    [tooltip]="(part.firstName || '') + ' ' + (part.lastName || '')"
                    containerClass="fitmed-tooltip"
                  >
                    {{ getInitials(part) }}
                  </div>
                }
              }
            </div>
          </div>
        }
      </div>
    </div>
  </div>
}
